import {
  faBoxArchive,
  faClock,
  faTrash,
} from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

export const PRIMARY_ACTIONS = [
  {
    icon: faClock,
    label: 'Snooze',
  },
  {
    icon: faBoxArchive,
    label: 'Archive',
  },
  {
    icon: faTrash,
    label: 'Delete',
  },
];

export const SECONDARY_ACTIONS = [
  'Mark as unread',
  'Star thread',
  'Add tag',
  'Mute thread',
];

export const TABS_CONFIG = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Unread',
    value: 'unread',
  },
];
